import React from 'react';
import { ModalPrompt } from 'lib/components/modal';
import { useQueryClient } from 'react-query';
import { guidesKeyes } from 'lib/api/guides/guidesKeyes';
import { useTranslation } from 'react-i18next';

interface LeaveWithoutSaveVisibilityProps {
  setOpen: (status: boolean) => void;
  closeModal: () => void;
}

export const LeaveWithoutSaveVisibility = ({
  setOpen,
  closeModal,
}: LeaveWithoutSaveVisibilityProps) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const close = () => setOpen(false);
  return (
    <ModalPrompt
      title={t('Are you sure you want to leave?')}
      content={
        <>
          {t("You may lose the info you've entered so far if you leave now.")}
        </>
      }
      secondaryButtonText={t('Keep editing')}
      primaryButtonText={t('Leave')}
      primaryButtonType={'destructive'}
      handleSubmit={() => {
        close();
        closeModal();
        queryClient.removeQueries(guidesKeyes.visibility());
      }}
      handleModalClose={close}
    />
  );
};
